import React, { useCallback, useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import "./Report.scss";

import { ArrowCircleLeft, ArrowCircleRight } from "@mui/icons-material";
import bg1 from "..//assets/analyticsbg.jpeg";
import bg2 from "../assets/1.jpg";
import bg4 from "../assets/ss1.png";
import bg6 from "../assets/chatBg_6.png";
import bg7 from "../assets/modestoBg1.png";
import page4bg from "../assets/reportBg3.jpeg";
import page5bg from "../assets/reportBg4.jpeg";
import video from "../assets/reportVideo.mp4";
import modestoBg1 from "../assets/modestoBg10.png";
import modestoBg2 from "../assets/modestoBg11.png";
import modestoBg3 from "../assets/modestoBg3.png";

import DataModal from "./DataModal";
import moment from "moment";

function Report(props: any): React.ReactElement {
  const bookRef: any = useRef();
  const [openDialog, setOpenDialog] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentData, setCurrentData] = useState("");

  const [isFlipping, setIsFlipping] = useState(false);

  const onFlip = useCallback((e: any) => {
    console.log("Current page: " + e.data);
    setCurrentPage(e.data);
  }, []);

  const handleClick = (dataType: string) => {
    setCurrentData(dataType);
    setOpenDialog(true);
  };

  return (
    <div className="report-main">
      <div
        style={{
          height: "100%",
          width: "100%",
          // backgroundColor: "red",
          position: "relative",
        }}
      >
        {currentPage > 0 && (
          <ArrowCircleLeft
            className="report-main__iconLeft"
            onClick={() => bookRef.current.pageFlip().flipPrev()}
          />
        )}
        <HTMLFlipBook
          ref={bookRef}
          width={300}
          height={600}
          size={"stretch"}
          disableFlipByClick={true}
          onFlip={onFlip}
          maxShadowOpacity={0.5}
          useMouseEvents={false}
          // onChangeState={(e: any) =>
          //   e.data === "read"
          //     ? setIsFlipping(false)
          //     : (e.data === "user_fold" || e.data === "flipping") &&
          //       setIsFlipping(true)
          // }
          // showCover={true}
        >
          <div data-density="soft">
            <div className="report-main__page1">
              <h1 className="report-main__page1__title">
                City Analysis & Prediction
              </h1>
              <p className="report-main__page1__text1">
                Swipe or drag to flip the pages, click to open items{" "}
              </p>
              <p className="report-main__page1__text1">
                <strong>Estate Intelligence 1.0</strong>
              </p>
              <p className="report-main__page1__text1">
                <strong>ONX Holdings Inc.,</strong>
              </p>
            </div>
          </div>
          <div data-density="soft">
            <div className="report-main__page2">
              <div
                style={{
                  position: "absolute",
                  left: "40px",
                  top: "30px",
                  display: "flex",
                }}
              >
                <div>
                  <div className="report-main__page2__cube"></div>
                  <div
                    className="report-main__page2__cube"
                    style={{ opacity: "0.5" }}
                  ></div>
                </div>
                <div>
                  <div
                    className="report-main__page2__cube"
                    style={{ opacity: "0.5" }}
                  ></div>
                  <div className="report-main__page2__cube"></div>
                </div>
                <div
                  style={{
                    color: "#F86738",
                    lineHeight: "20px",
                    fontSize: "16px",
                    position: "absolute",
                    top: "252px",
                    fontWeight: 300,
                    textIndent: "1px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Land Purchase Analysis FY2023
                </div>
              </div>
              <div style={{ padding: "30px 20px 5px 0" }}>
                <h1
                  style={{
                    color: "rgba(255,255,255,0.9)",
                    textAlign: "right",
                    fontWeight: 300,
                    fontSize: "30px",
                    textTransform: "uppercase",
                    // margin: "0 0 0 60%",
                    lineHeight: "40px",
                    cursor: "default",
                    whiteSpace: "nowrap",
                    paddingBottom: "10px",
                    marginTop: "5px",
                  }}
                >
                  Executive Report <br></br> prepared for<br></br>
                  <strong>Senthil Kumar</strong>
                  {/* <span
                    style={{
                      display: "block",
                      fontWeight: 300,
                      fontSize: "15px",
                    }}
                  >
                    Go Ahead{" "}
                    <a
                      style={{ color: "#F86738", textDecoration: "none" }}
                      href="https://flipboard.com/"
                    >
                      Flip
                    </a>
                  </span> */}
                </h1>
              </div>
              <div
                style={{
                  color: "rgba(255,255,255,0.9)",
                  fontWeight: 600,
                  fontSize: "40px",
                  lineHeight: "46px",
                  position: "absolute",
                  bottom: "54%",
                  left: "40px",
                  margin: 0,
                  textTransform: "uppercase",
                  cursor: "default",
                  whiteSpace: "nowrap",
                }}
              >
                <span
                  style={{
                    color: "#F86738",
                    display: "block",
                    fontSize: "26px",
                    lineHeight: "26px",
                  }}
                >
                  Analysis Report
                </span>
                Analysis of Modesto
              </div>
              <div
                style={{
                  background: "#000",
                  color: "#ddd",
                  position: "absolute",
                  right: "0px",
                  padding: "10px 30px 10px 20px",
                  fontSize: "24px",
                  textTransform: "uppercase",
                  fontWeight: "normal",
                  top: "25%",
                  marginTop: "-25px",
                  cursor: "pointer",
                }}
                onClick={() => bookRef.current.pageFlip().flipNext()}
              > 
                {"> "}
                <span style={{ marginLeft: "0.2rem" }}>Flip</span>
              </div>
            </div>
          </div>
          <div data-density="soft">
            <div
              className="report-main__page3"
              style={{ width: isFlipping ? "100%" : "200%" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  height: "3%",
                  alignItems: "center",
                }}
              >
                <a
                  className="report-main__page3__titleSmall"
                  href="https://realestate.dev.slate.ai/"
                >
                  Home
                </a>
                <h2 className="report-main__page3__title">
                  Modesto 2024 Analysis
                </h2>
                <a
                  className="report-main__page3__titleSmall"
                  href="https://realestate.dev.slate.ai/"
                >
                  ONX Holdings Inc.,
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  height: "30%",
                  // backgroundColor: "darkcyan",
                  overflow: "hidden",
                  padding: "0 1rem",
                  border: "1px solid #f2f2f2",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "25%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    flexDirection: "column",
                    padding: "1rem",
                    borderRight: "1px solid #f2f2f2",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick("1_1")}
                >
                  <div>
                    <img
                      src={modestoBg1}
                      style={{ height: "12rem", width: "100%" }}
                    ></img>
                  </div>

                  {/* <div>
                    <video
                      width="100%"
                      height="100%"
                      controls={false}
                      autoPlay={true}
                      muted
                      loop
                    >
                      <source src={video} type="video/mp4" />
                    </video>
                    
                  </div> */}
                  <h3 className="report-main__head">
                    Geography Analyzed: Modesto, CA{" "}
                    <span className="report-main__head__span">
                      Analyzed on {moment().format("MMM DD, YYYY")}
                    </span>
                  </h3>
                  <p className="report-main__text">
                    Modesto is the largest city and the county seat of
                    Stanislaus County. Modesto is situated about 92 miles east
                    of San Francisco, 68 miles south of the state capital of
                    Sacramento, and 66 miles west of Yosemite National Park. It
                    is the 18th largest city in California with a population of
                    about 250K. Modesto is a major center for agriculture, due
                    to the fertile farmland that surrounds the city. It's known
                    for its production of milk, almonds, chickens, walnuts, and
                    corn. Modesto has a rich and diverse cultural scene for a
                    city of its size, which includes the Gallo Center for the
                    Arts, the Modesto Nuts minor league baseball team (a
                    Colorado Rockies affiliate), and the annual Modesto
                    Certified Farmer's Market. The city's climate is a
                    Mediterranean climate, characterized by mild winters with
                    moderate rainfall and hot, dry summers. One of the city's
                    more notable characteristics is its motto: "Water Wealth
                    Contentment Health," which is noted as one of the world's
                    unique non- commercial city mottos.
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "1rem",
                    width: "50%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    borderRight: "1px solid #f2f2f2",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick("1_2")}
                >
                  <div style={{ textAlign: "center" }}>
                    {/* <Price /> */}
                    <img
                      src={modestoBg2}
                      style={{ height: "17.5rem", width: "80%" }}
                    ></img>
                  </div>
                  <h3 className="report-main__head">
                    Prices and Demand
                    <span className="report-main__head__span">
                      Analyzed on {moment().format("MMM DD, YYYY")}
                    </span>
                  </h3>
                  <p className="report-main__text">
                    The housing market in Modesto is highly competitive. In
                    April 2023, there was a 2.2% decrease in Modesto home prices
                    compared to the previous year, with homes selling at a
                    median price of $440K. On average, homes in Modesto were on
                    the market for 9 days, slightly longer than the 8 days
                    observed last year. Many homes receive multiple offers, some
                    of which have waived contingencies. Typically, homes sell
                    close to their listed price and go pending within
                    approximately 13 days. In cases where the demand is
                    particularly high, hot homes can sell for approximately 2%
                    above the list price and go pending in about 5 days.
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "25%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    padding: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick("1_3")}
                >
                  <div>
                    <img
                      src={bg7}
                      style={{ height: "14rem", width: "100%" }}
                    ></img>
                  </div>
                  <h3 className="report-main__head">
                    Vulnerability{" "}
                    <span className="report-main__head__span">
                      Analyzed on {moment().format("MMM DD, YYYY")}
                    </span>
                  </h3>
                  <p className="report-main__text">
                    During the last 12 months the real estate prices in
                    Stanislaus, Modesto City increased, looking at the past 12
                    months. According to our Predictions of the Modesto real
                    estate market, home values will decrease in the next 12
                    months. Median home values increased by 1.7% to 303673 USD,
                    between May 2022 and May 2023 The average annual profit of
                    property investment was:
                    <ul>
                      <li>5.6% in 2018</li>
                      <li>3.7% in 2019 </li>
                      <li>-4.5% in 2020 </li>
                      <li>0.3% in 2021 </li>
                      <li>2.3% in 2022</li>
                    </ul>
                    Based on our Predictions the sales prices will increase by
                    18% in the next 10 years. Over the last 12 months, the value
                    of homes in Modesto City fluctuated: increasing 10 times and
                    decreasing 2 times.
                  </p>
                </div>
                <div className="report-main__padding"></div>
              </div>
              <div
                style={{
                  display: "flex",
                  height: "15%",
                  // backgroundColor: "firebrick",
                  overflow: "hidden",
                  padding: "0 1rem",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "50%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    padding: "1rem",
                    borderRight: "1px solid #f2f2f2",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick("1_4")}
                >
                  <h3 className="report-main__head">
                    Industries{" "}
                    <span className="report-main__head__span">
                      Analyzed on {moment().format("MMM DD, YYYY")}
                    </span>
                  </h3>
                  <p className="report-main__text">
                    <ul>
                      <li>
                        From 2019 to 2020, employment in Modesto, CA grew at a
                        rate of 1.26%, from 228k employees to 231k employees.{" "}
                      </li>
                      <li>
                        The most common employment sectors for those who live in
                        Modesto, CA, are Health Care & Social Assistance (30,367
                        people), Retail Trade (28,098 people), and Manufacturing
                        (27,461 people). This chart shows the share breakdown of
                        the primary industries for residents of Modesto, CA,
                        though some of these residents may live in Modesto, CA
                        and work somewhere else. Census data is tagged to a
                        residential address, not a work address.
                      </li>
                    </ul>
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "50%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    padding: "1rem",
                    cursor: "pointer",

                    // borderRight: "1px solid #f2f2f2",
                  }}
                  onClick={() => handleClick("1_5")}
                >
                  <h3 className="report-main__head">
                    Occupation{" "}
                    <span className="report-main__head__span">
                      Analyzed on {moment().format("MMM DD, YYYY")}
                    </span>
                  </h3>
                  <p className="report-main__text">
                    {/* <ul>
                      <li> */}
                    Over the past few years. employment in Modesto, CA grew at a
                    rate of 1.26%, from 228k employees to 231k employees.
                    {/* </li>
                      <li> */}
                    <div>
                      The most common job groups, by number of people living in
                      Modesto, CA, are Office & Administrative Support
                      Occupations (25,050 people), Sales & Related Occupations
                      (23,134 people), and Management Occupations (18,734
                      people).
                    </div>
                    Modesto's proximity to silicon valley and relative housing
                    prices make it a destination for the employees to live in
                    Modesto and work in the valley. This trend is expected to
                    increase in the coming years.
                    {/* </li>
                    </ul> */}
                  </p>
                </div>
                <div
                  className="report-main__padding"
                  // style={{ height: "51rem" }}
                ></div>
              </div>
            </div>
          </div>
          <div className="report-main__hideDisplay" data-density="soft"></div>
          <div data-density="soft">
            <div
              className="report-main__page4"
              style={{ width: isFlipping ? "100%" : "200%" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  height: "3%",
                  alignItems: "center",
                }}
              >
                <a
                  className="report-main__page3__titleSmall"
                  href="https://realestate.dev.slate.ai/"
                >
                  Previous Demo
                </a>
                <h2 className="report-main__page3__title">
                  2024 Executive Summary
                </h2>
                <a
                  className="report-main__page3__titleSmall"
                  href="https://realestate.dev.slate.ai/"
                >
                  ONX Holdings Inc.,
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  height: "22%",
                  // backgroundColor: "darkcyan",
                  overflow: "hidden",
                  padding: "0 1rem",
                  border: "1px solid #f2f2f2",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "75%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    flexDirection: "row",
                    padding: "1rem",
                    borderRight: "1px solid #f2f2f2",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick("2_1")}
                >
                  <div style={{ paddingRight: "1rem" }}>
                    <img
                      src={page4bg}
                      style={{ height: "100%", width: "380rem" }}
                    ></img>
                  </div>
                  <div>
                    <h3 className="report-main__head">
                      Where would we invest a $1000 for max ROI
                      <span className="report-main__head__span">
                        Analyzed on {moment().format("MMM DD, YYYY")}
                      </span>
                    </h3>
                    <p className="report-main__text">
                      Consectetur locavore brooklyn dreamcatcher, aesthetic anim
                      dolor put a bird on it semiotics godard pork belly forage.
                      VHS veniam aliqua thundercats dolore keffiyeh, direct
                      trade authentic PBR eiusmod. Dolore veniam fanny pack,
                      proident iphone mixtape irure sed. Lo-fi leggings
                      stumptown cardigan etsy, pitchfork echo park terry
                      richardson next level labore proident. Messenger bag
                      cillum squid scenester, before they sold out dolor nostrud
                      ad bicycle rights. Ut ex bicycle rights, wes anderson
                      thundercats duis synth gluten-free hoodie twee. Four loko
                      artisan viral, letterpress dreamcatcher twee yr cray vegan
                      enim photo booth 3 wolf moon. Id veniam mustache squid,
                      cliche terry richardson organic quis dreamcatcher
                      skateboard. Chambray before they sold out yr, iphone
                      street art ut locavore squid placeat you probably haven't
                      heard of them small batch. Cred proident occaecat wolf,
                      fixie letterpress est biodiesel kogi gentrify. Artisan +1
                      culpa, bicycle rights trust fund direct trade consectetur
                      gentrify synth pariatur twee delectus consequat wayfarers
                      deserunt. Helvetica ex godard selvage, sriracha echo park
                      ut portland forage cardigan. Retro readymade williamsburg
                      cliche laboris pinterest. Mollit aliqua direct trade,
                      tumblr vegan lo-fi shoreditch semiotics sed 8-bit.
                      Incididunt keffiyeh PBR cray, assumenda yr butcher nisi.
                      Mustache brunch kogi, farm-to-table small batch odio
                      fugiat consequat fap esse quinoa. Iphone banh mi brunch
                      jean shorts sartorial, letterpress culpa direct trade
                      master cleanse banksy fap whatever quinoa biodiesel.
                      Portland eiusmod minim nihil Austin, sartorial aesthetic
                      occupy tofu sriracha pitchfork seitan.
                    </p>
                    <div className="report-main__padding"></div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "25%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    padding: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick("2_2")}
                >
                  {/* <div>
                    <img
                      src={bg2}
                      style={{ height: "10rem", width: "100%" }}
                    ></img>
                  </div> */}
                  <div>
                    <video
                      width="100%"
                      height="100%"
                      controls={false}
                      autoPlay={true}
                      muted
                      loop
                    >
                      <source src={video} type="video/mp4" />
                    </video>
                  </div>
                  <h3 className="report-main__head">
                    Highways & Traffic
                    <span className="report-main__head__span">
                      Analyzed on {moment().format("MMM DD, YYYY")}
                    </span>
                  </h3>
                  <p className="report-main__text">
                    Ethical 3 wolf moon sartorial nihil consequat twee, officia
                    banh mi scenester carles vero thundercats. Keffiyeh mlkshk
                    cliche craft beer, sartorial bespoke flexitarian helvetica
                    consequat. Echo park organic nihil nostrud brooklyn
                    scenester, delectus bushwick est narwhal sriracha. Chambray
                    terry richardson direct trade, tumblr keffiyeh semiotics
                    minim post-ironic. Sapiente nostrud banksy in nisi, lo-fi
                    kale chips polaroid retro. 8-bit you probably haven't heard
                    of them bespoke cred portland trust fund yr dolore sed. Art
                    party quis street art american apparel lomo. Helvetica ex
                    godard selvage, sriracha echo park ut portland forage
                    cardigan. Retro readymade williamsburg cliche laboris
                    pinterest. Mollit aliqua direct trade, tumblr vegan lo-fi
                    shoreditch semiotics sed 8-bit. Incididunt keffiyeh PBR
                    cray, assumenda yr butcher nisi. Mustache brunch kogi,
                    farm-to-table small batch odio fugiat consequat fap esse
                    quinoa. Iphone banh mi brunch jean shorts sartorial,
                    letterpress culpa direct trade master cleanse banksy fap
                    whatever quinoa biodiesel. Portland eiusmod minim nihil
                    Austin, sartorial aesthetic occupy tofu sriracha pitchfork
                    seitan.
                  </p>
                  <div className="report-main__padding"></div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  height: "23%",
                  // backgroundColor: "firebrick",
                  overflow: "hidden",
                  padding: "0 1rem",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "28%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    padding: "1rem",
                    cursor: "pointer",
                    borderRight: "1px solid #f2f2f2",
                    position: "relative",
                  }}
                  onClick={() => handleClick("2_3")}
                >
                  {/* <div>
                    <img
                      src={bg7}
                      style={{ height: "10rem", width: "100%" }}
                    ></img>
                  </div> */}
                  <h3 className="report-main__head">
                    What-If Analysis Summary{" "}
                    <span className="report-main__head__span">
                      Analyzed on {moment().format("MMM DD, YYYY")}
                    </span>
                  </h3>
                  <p className="report-main__text">
                    Salvia +1 pork belly cosby sweater, lo-fi wolf tattooed VHS.
                    Before they sold out dolore cray flexitarian et VHS +1 trust
                    fund. Typewriter squid fap aute wolf 3 wolf moon, vice
                    cillum street art. Austin organic gluten-free, ex cosby
                    sweater odio squid. Iphone high life sriracha, +1 cupidatat
                    assumenda shoreditch exercitation wayfarers. Aesthetic
                    selvage nesciunt ennui. Nisi anim single-origin coffee,
                    ullamco bushwick delectus fanny pack marfa tumblr cliche.
                    Helvetica ex godard selvage, sriracha echo park ut portland
                    forage cardigan. Retro readymade williamsburg cliche laboris
                    pinterest. Mollit aliqua direct trade, tumblr vegan lo-fi
                    shoreditch semiotics sed 8-bit. Incididunt keffiyeh PBR
                    cray, assumenda yr butcher nisi. Mustache brunch kogi,
                    farm-to-table small batch odio fugiat consequat fap esse
                    quinoa. Iphone banh mi brunch jean shorts sartorial,
                    letterpress culpa direct trade master cleanse banksy fap
                    whatever quinoa biodiesel. Portland eiusmod minim nihil
                    Austin, sartorial aesthetic occupy tofu sriracha pitchfork
                    seitan.
                  </p>
                  <div className="report-main__padding"></div>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "72%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    flexDirection: "row",
                    padding: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick("2_4")}
                >
                  <div style={{ paddingRight: "1rem" }}>
                    <img
                      src={bg6}
                      style={{ height: "100%", width: "380rem" }}
                    ></img>
                  </div>
                  <div>
                    <h3 className="report-main__head">
                      Secondary Modifiers
                      <span className="report-main__head__span">
                        Analyzed on {moment().format("MMM DD, YYYY")}
                      </span>
                    </h3>
                    <p className="report-main__text">
                      Consectetur locavore brooklyn dreamcatcher, aesthetic anim
                      dolor put a bird on it semiotics godard pork belly forage.
                      VHS veniam aliqua thundercats dolore keffiyeh, direct
                      trade authentic PBR eiusmod. Dolore veniam fanny pack,
                      proident iphone mixtape irure sed. Lo-fi leggings
                      stumptown cardigan etsy, pitchfork echo park terry
                      richardson next level labore proident. Messenger bag
                      cillum squid scenester, before they sold out dolor nostrud
                      ad bicycle rights. Ut ex bicycle rights, wes anderson
                      thundercats duis synth gluten-free hoodie twee. Four loko
                      artisan viral, letterpress dreamcatcher twee yr cray vegan
                      enim photo booth 3 wolf moon. Semiotics mlkshk anim
                      sustainable butcher tempor. Odio single-origin coffee raw
                      denim consequat mcsweeney's retro bespoke. Vero voluptate
                      minim, letterpress accusamus twee farm-to-table pariatur
                      cray. Helvetica ex godard selvage, sriracha echo park ut
                      portland forage cardigan. Retro readymade williamsburg
                      cliche laboris pinterest. Mollit aliqua direct trade,
                      tumblr vegan lo-fi shoreditch semiotics sed 8-bit.
                      Incididunt keffiyeh PBR cray, assumenda yr butcher nisi.
                      Mustache brunch kogi, farm-to-table small batch odio
                      fugiat consequat fap esse quinoa. Iphone banh mi brunch
                      jean shorts sartorial, letterpress culpa direct trade
                      master cleanse banksy fap whatever quinoa biodiesel.
                      Portland eiusmod minim nihil Austin, sartorial aesthetic
                      occupy tofu sriracha pitchfork seitan.
                    </p>
                    <div className="report-main__padding"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="report-main__hideDisplay" data-density="soft"></div>
          <div data-density="soft">
            <div
              className="report-main__page5"
              style={{ width: isFlipping ? "100%" : "200%" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  height: "3%",
                  alignItems: "center",
                }}
              >
                <a
                  className="report-main__page3__titleSmall"
                  href="https://realestate.dev.slate.ai/"
                >
                  Previous Demo
                </a>
                <h2 className="report-main__page3__title">
                  2024 Executive Summary
                </h2>
                <a
                  className="report-main__page3__titleSmall"
                  href="https://realestate.dev.slate.ai/"
                >
                  ONX Holdings Inc.,
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  height: "23%",
                  // backgroundColor: "darkcyan",
                  overflow: "hidden",
                  padding: "0 1rem",
                  border: "1px solid #f2f2f2",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "28%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    padding: "1rem",
                    cursor: "pointer",
                    borderRight: "1px solid #f2f2f2",
                    position: "relative",
                  }}
                  onClick={() => handleClick("3_1")}
                >
                  {/* <div>
                    <img
                      src={bg2}
                      style={{ height: "10rem", width: "100%" }}
                    ></img>
                  </div> */}
                  <h3 className="report-main__head">
                    Vulnerability Summary{" "}
                    <span className="report-main__head__span">
                      Analyzed on {moment().format("MMM DD, YYYY")}
                    </span>
                  </h3>
                  <p className="report-main__text">
                    Accusamus yr gluten-free id. Ennui occupy scenester
                    polaroid, incididunt VHS minim sustainable skateboard aute
                    cillum retro. Odd future gluten-free excepteur retro,
                    biodiesel jean shorts minim nisi. Mlkshk hoodie next level
                    pop-up 8-bit. Butcher scenester aliqua, tumblr nisi
                    mcsweeney's PBR pork belly bespoke keytar cillum laboris
                    swag pitchfork. Fugiat et eu american apparel truffaut
                    brooklyn minim. Incididunt quis pickled, chillwave +1 odio
                    dolore freegan est pop-up before they sold out twee cliche
                    echo park ut. In high life swag tofu ethnic 8-bit, seitan
                    pinterest DIY lomo post-ironic. Helvetica ex godard selvage,
                    sriracha echo park ut portland forage cardigan. Retro
                    readymade williamsburg cliche laboris pinterest. Mollit
                    aliqua direct trade, tumblr vegan lo-fi shoreditch semiotics
                    sed 8-bit. Incididunt keffiyeh PBR cray, assumenda yr
                    butcher nisi. Mustache brunch kogi, farm-to-table small
                    batch odio fugiat consequat fap esse quinoa. Iphone banh mi
                    brunch jean shorts sartorial, letterpress culpa direct trade
                    master cleanse banksy fap whatever quinoa biodiesel.
                    Portland eiusmod minim nihil Austin, sartorial aesthetic
                    occupy tofu sriracha pitchfork seitan.
                  </p>
                  <div className="report-main__padding"></div>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "72%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    flexDirection: "row",
                    padding: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick("3_2")}
                >
                  <div style={{ paddingRight: "1rem" }}>
                    <img
                      src={bg4}
                      style={{ height: "100%", width: "380rem" }}
                    ></img>
                  </div>
                  <div>
                    <h3 className="report-main__head">
                      Data Quality Analysis
                      <span className="report-main__head__span">
                        Analyzed on {moment().format("MMM DD, YYYY")}
                      </span>
                    </h3>
                    <p className="report-main__text">
                      Wes anderson trust fund organic pour-over, aute authentic
                      high life fanny pack enim. Ethnic mumblecore salvia,
                      letterpress minim velit fugiat sartorial beard mixtape
                      vice ad. Farm-to-table aute cred cosby sweater sed, dolore
                      pork belly pinterest keytar 3 wolf moon mustache. Vice
                      thundercats pour-over, lo-fi echo park accusamus ullamco
                      adipisicing selvage street art you probably haven't heard
                      of them etsy. Readymade bushwick mumblecore whatever
                      aesthetic, do nesciunt direct trade proident culpa. Vegan
                      you probably haven't heard of them hoodie adipisicing qui,
                      voluptate Austin stumptown photo booth sed. Mixtape
                      excepteur locavore eu, labore sustainable nisi tofu
                      narwhal fanny pack VHS nulla aliqua. Beard velit street
                      art aute sartorial. Sapiente pitchfork polaroid, fugiat ea
                      DIY williamsburg forage officia sint occaecat. Gentrify
                      exercitation cray marfa, blog biodiesel readymade aliquip
                      beard placeat raw denim stumptown. Austin photo booth
                      accusamus et semiotics. Messenger bag ethical direct trade
                      ullamco jean shorts. Selvage authentic seitan direct trade
                      delectus butcher, mollit occupy cillum photo booth banksy
                      proident gentrify commodo vice. Retro qui cray whatever.
                      Helvetica ex godard selvage, sriracha echo park ut
                      portland forage cardigan. Retro readymade williamsburg
                      cliche laboris pinterest. Mollit aliqua direct trade,
                      tumblr vegan lo-fi shoreditch semiotics sed 8-bit.
                      Incididunt keffiyeh PBR cray, assumenda yr butcher nisi.
                      Mustache brunch kogi, farm-to-table small batch odio
                      fugiat consequat fap esse quinoa. Iphone banh mi brunch
                      jean shorts sartorial, letterpress culpa direct trade
                      master cleanse banksy fap whatever quinoa biodiesel.
                      Portland eiusmod minim nihil Austin, sartorial aesthetic
                      occupy tofu sriracha pitchfork seitan.
                    </p>
                    <div className="report-main__padding"></div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  height: "22%",
                  // backgroundColor: "firebrick",
                  overflow: "hidden",
                  padding: "0 1rem",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "40%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    flexDirection: "row",
                    padding: "1rem",
                    cursor: "pointer",
                    borderRight: "1px solid #f2f2f2",
                  }}
                  onClick={() => handleClick("3_3")}
                >
                  <div style={{ paddingRight: "1rem" }}>
                    <img
                      src={modestoBg3}
                      style={{ height: "100%", width: "380rem" }}
                    ></img>
                  </div>
                  <div>
                    <h3 className="report-main__head">
                      Predicted Traffic Patterns
                      <span className="report-main__head__span">
                        Analyzed on {moment().format("MMM DD, YYYY")}
                      </span>
                    </h3>
                    <p className="report-main__text">
                      This region is expected to see tremendous vehicular
                      traffic growth over the next 2-4 years. This is because of
                      the growing neighbourhoods and projected commute
                      patterns.The county has invested in couple of highways
                      development project. While that is helpful in easing the
                      congestion it will also increase the vehicular traffic.
                      Mcsweeney's pitchfork chambray tattooed four loko, commodo
                      nesciunt lo-fi dreamcatcher mixtape eu occaecat vinyl
                      cupidatat. Delectus selvage gentrify, commodo fingerstache
                      jean shorts sriracha you probably haven't heard of them
                      aesthetic. Bespoke nulla eiusmod deserunt, qui 8-bit +1
                      high life proident dolor small batch accusamus laborum
                      ethical. In high life swag tofu ethnic 8-bit, seitan
                      pinterest DIY lomo post-ironic. American apparel
                      fingerstache portland, lomo thundercats small batch velit
                      quis letterpress. Dolore iphone accusamus pitchfork
                      authentic. Qui narwhal voluptate, street art keffiyeh non
                      laborum. Helvetica ex godard selvage, sriracha echo park
                      ut portland forage cardigan. Retro readymade williamsburg
                      cliche laboris pinterest. Mollit aliqua direct trade,
                      tumblr vegan lo-fi shoreditch semiotics sed 8-bit.
                      Incididunt keffiyeh PBR cray, assumenda yr butcher nisi.
                      Mustache brunch kogi, farm-to-table small batch odio
                      fugiat consequat fap esse quinoa. Iphone banh mi brunch
                      jean shorts sartorial, letterpress culpa direct trade
                      master cleanse banksy fap whatever quinoa biodiesel.
                      Portland eiusmod minim nihil Austin, sartorial aesthetic
                      occupy tofu sriracha pitchfork seitan.
                    </p>
                    <div className="report-main__padding"></div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "30%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    flexDirection: "row",
                    padding: "1rem",
                    cursor: "pointer",
                    borderRight: "1px solid #f2f2f2",
                  }}
                  onClick={() => handleClick("3_4")}
                >
                  {/* <div style={{ paddingRight: "1rem" }}>
                    <img
                      src={bg6}
                      style={{ height: "100%", width: "25rem" }}
                    ></img>
                  </div> */}
                  <div>
                    <h3 className="report-main__head">
                      Secondary Modifiers
                      <span className="report-main__head__span">
                        Analyzed on {moment().format("MMM DD, YYYY")}
                      </span>
                    </h3>
                    <p className="report-main__text">
                      Authentic put a bird on it mustache magna. Terry
                      richardson dolor vero, magna odio synth letterpress umami
                      brunch vice craft beer Austin. Velit mcsweeney's consequat
                      wes anderson. Yr eu minim id. Pinterest odio keytar, irony
                      bushwick pickled delectus placeat 3 wolf moon trust fund.
                      Small batch mixtape carles chambray aute pop-up
                      reprehenderit, portland magna skateboard vero
                      dreamcatcher. Id artisan twee tempor excepteur pitchfork.
                      Helvetica ex godard selvage, sriracha echo park ut
                      portland forage cardigan. Retro readymade williamsburg
                      cliche laboris pinterest. Mollit aliqua direct trade,
                      tumblr vegan lo-fi shoreditch semiotics sed 8-bit.
                      Incididunt keffiyeh PBR cray, assumenda yr butcher nisi.
                      Mustache brunch kogi, farm-to-table small batch odio
                      fugiat consequat fap esse quinoa. Iphone banh mi brunch
                      jean shorts sartorial, letterpress culpa direct trade
                      master cleanse banksy fap whatever quinoa biodiesel.
                      Portland eiusmod minim nihil Austin, sartorial aesthetic
                      occupy tofu sriracha pitchfork seitan.
                    </p>
                    <div className="report-main__padding"></div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "30%",
                    // backgroundColor: "beige",
                    overflow: "hidden",
                    flexDirection: "row",
                    padding: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick("3_5")}
                >
                  {/* <div style={{ paddingRight: "1rem" }}>
                    <img
                      src={bg6}
                      style={{ height: "100%", width: "25rem" }}
                    ></img>
                  </div> */}
                  <div>
                    <h3 className="report-main__head">
                      What-If Scenario Analysis Summary
                      <span className="report-main__head__span">
                        Analyzed on {moment().format("MMM DD, YYYY")}
                      </span>
                    </h3>
                    <p className="report-main__text">
                      Nisi anim raw denim, occupy seitan magna selvage pork
                      belly leggings gluten-free. Street art consequat aliquip,
                      echo park helvetica enim pariatur fanny pack aesthetic et
                      laboris pickled jean shorts ethical. Austin pop-up next
                      level esse, retro quinoa locavore mollit etsy elit
                      nesciunt quis salvia beard. Quis magna consequat selvage,
                      ullamco commodo exercitation. VHS polaroid fugiat quis
                      gastropub, cosby sweater aliquip aesthetic velit jean
                      shorts swag. Put a bird on it etsy pork belly synth nisi,
                      pitchfork wes anderson semiotics cliche ea. Cliche officia
                      cosby sweater ullamco, quis stumptown est blog vinyl pork
                      belly. Helvetica ex godard selvage, sriracha echo park ut
                      portland forage cardigan. Retro readymade williamsburg
                      cliche laboris pinterest. Mollit aliqua direct trade,
                      tumblr vegan lo-fi shoreditch semiotics sed 8-bit.
                      Incididunt keffiyeh PBR cray, assumenda yr butcher nisi.
                      Mustache brunch kogi, farm-to-table small batch odio
                      fugiat consequat fap esse quinoa. Iphone banh mi brunch
                      jean shorts sartorial, letterpress culpa direct trade
                      master cleanse banksy fap whatever quinoa biodiesel.
                      Portland eiusmod minim nihil Austin, sartorial aesthetic
                      occupy tofu sriracha pitchfork seitan.
                    </p>
                    <div className="report-main__padding"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="report-main__hideDisplay" data-density="soft"></div>
        </HTMLFlipBook>
        {currentPage > 0 && currentPage !== 6 && (
          <ArrowCircleRight
            className="report-main__iconRight"
            onClick={() => bookRef.current.pageFlip().flipNext()}
          />
        )}
      </div>
      <DataModal
        data={currentData}
        open={openDialog}
        handleClose={() => setOpenDialog(false)}
      />
    </div>
  );
}

export default Report;
